namespace e5 {
    export interface LoaderDecoderMap {
    }

    export interface Decoder {
        responseType: XMLHttpRequestResponseType;
        decode?(ajax: XMLHttpRequest): Promise<any>;
    }

    type DecoderLookup = {
        [P in keyof LoaderDecoderMap]?: Decoder;
    }

    export const decoders: DecoderLookup = {};

    export function registerDecoder<T extends keyof LoaderDecoderMap>(key: T, decoder: LoaderDecoderMap[T]): void {
        decoders[key] = decoder;
    }

    /**
     * JSON decoder
     */
    class JsonDecoder implements Decoder {
        public responseType: XMLHttpRequestResponseType = "json";
        public async decode(ajax: XMLHttpRequest): Promise<any> {

            if (Caps.isInternetExplorer && Caps.msieVersion <= 11) {
                return JSON.parse(ajax.responseText);
            }

            return ajax.response;
        }
    }

    export interface LoaderDecoderMap {
        "json": JsonDecoder;
    }

    registerDecoder("json", new JsonDecoder());

    /**
     * HTML decoder
     */
    class HtmlDecoder implements Decoder {
        public responseType: XMLHttpRequestResponseType = "text";
        public async decode(ajax: XMLHttpRequest): Promise<any> {
            var div = document.createElement("div");
            div.innerHTML = ajax.responseText;
            return div.firstChild;
        }
    }

    export interface LoaderDecoderMap {
        "html": SvgDecoder;
    }

    registerDecoder("html", new HtmlDecoder());

    /**
     * SVG decoder
     */
    class SvgDecoder implements Decoder {
        public responseType: XMLHttpRequestResponseType = "text";
        public async decode(ajax: XMLHttpRequest): Promise<any> {
            var div = document.createElement("div");
            div.innerHTML = ajax.responseText;
            return div.firstChild as SVGElement;
        }
    }

    export interface LoaderDecoderMap {
        "svg": SvgDecoder;
    }

    registerDecoder("svg", new SvgDecoder());

    /**
     * Blob decoder
     */
    class BlobDecoder implements Decoder {
        public responseType: XMLHttpRequestResponseType = "blob";
    }

    export interface LoaderDecoderMap {
        "blob": BlobDecoder;
    }

    registerDecoder("blob", new BlobDecoder());

    /**
     * ArrayBuffer decoder
     */
    class ArrayBufferDecoder implements Decoder {
        public responseType: XMLHttpRequestResponseType = "arraybuffer";
    }

    export interface LoaderDecoderMap {
        "arraybuffer": ArrayBufferDecoder;
    }

    registerDecoder("arraybuffer", new ArrayBufferDecoder());

    /**
     * Text decoder
     */
    class TextDecoder implements Decoder {
        public responseType: XMLHttpRequestResponseType = "text";
    }

    export interface LoaderDecoderMap {
        "text": TextDecoder;
    }

    registerDecoder("text", new TextDecoder());

    /**
     * Document decoder
     */
    class DocumentDecoder implements Decoder {
        public responseType: XMLHttpRequestResponseType = "document";
    }

    export interface LoaderDecoderMap {
        "document": DocumentDecoder;
    }

    registerDecoder("document", new DocumentDecoder());
}